import React, {useState} from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  TableContainer,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Flex,
} from "@chakra-ui/react";
import Mark from "./Mark";
import { FaList } from "react-icons/fa";

const colorMap = {
  1: "red.500",
  2: "green.500",
  3: "purple.500",
  4: "yellow.500",
  5: "blue.500",
};

export default function ArchiveModal({ isOpen, onClose, archiveData }) {
  const [isRemarksModalOpen, setIsRemarksModalOpen] = useState(false);
  const [selectedUserRemarks, setSelectedUserRemarks] = useState(null);

  const openRemarksModal = (remarks) => {
    setSelectedUserRemarks(remarks);
    setIsRemarksModalOpen(true);
  };

  const closeRemarksModal = () => {
    setIsRemarksModalOpen(false);
    setSelectedUserRemarks(null);
  };


  return (
    <>
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Podgląd zarchiwizowanej kompanii</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TableContainer>
            <Table variant="striped" colorScheme="cos">
              <Thead>
                <Tr>
                  <Th>Pluton</Th>
                  <Th>Numer</Th>
                  <Th>Login</Th>
                  <Th>Oceny</Th>
                  <Th>Obecności OB | NB | U</Th>
                  <Th>Uwagi</Th>
                </Tr>
              </Thead>
              <Tbody>
                {archiveData
                .sort((a, b) => a.platoon - b.platoon || a.number - b.number)
                .map((user, index) => {
                  const totalOB = user.attendance.reduce(
                    (sum, att) =>
                      sum + (att.number === user.number ? att.OB : 0),
                    0
                  );
                  const totalNB = user.attendance.reduce(
                    (sum, att) =>
                      sum + (att.number === user.number ? att.NB : 0),
                    0
                  );
                  const totalU = user.attendance.reduce(
                    (sum, att) =>
                      sum + (att.number === user.number ? att.U : 0),
                    0
                  );

                  return (
                    <Tr key={index}>
                      <Td>{user.platoon}</Td>
                      <Td>{user.number}</Td>
                      <Td>{user.login}</Td>
                      <Td>
                        <Flex gap={1}>
                          {user.marks.map((mark, idx) => (
                            <Mark
                              key={idx}
                              mark={mark.mark}
                              color={mark.color}
                              addedBy={mark.addedBy}
                              comment={mark.comment}
                              markId={mark.id}
                            />
                          ))}
                        </Flex>
                      </Td>
                      <Td>
                        <Flex gap={1}>
                          <Mark mark={totalOB} color="5" />
                          <Mark mark={totalNB} color="red.500" />
                          <Mark mark={totalU} color="4" />
                        </Flex>
                      </Td>
                      <Td>
                        <Flex gap={1} alignItems={"center"}>
                          <Mark mark={user.remarks.positive.length} color="2" />
                          <Mark
                            mark={user.remarks.negative.length}
                            color="red.500"
                          />
                          <Button size="xs" colorScheme="orange" ml="2" onClick={() => openRemarksModal(user.remarks)}>
                            <FaList />
                          </Button>
                        </Flex>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Zamknij
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>

    {selectedUserRemarks && (
        <Modal isOpen={isRemarksModalOpen} onClose={closeRemarksModal} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Szczegóły uwag</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>Typ</Th>
                      <Th>Treść</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {selectedUserRemarks.positive.map((remark, idx) => (
                      <Tr key={idx}>
                        <Td>Pozytywna</Td>
                        <Td>{remark}</Td>
                      </Tr>
                    ))}
                    {selectedUserRemarks.negative.map((remark, idx) => (
                      <Tr key={idx}>
                        <Td>Negatywna</Td>
                        <Td>{remark}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={closeRemarksModal}>
                Zamknij
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}
